module.exports = __webpack_public_path__ + "img/u12441.954deb69.png";